import { Separator } from 'design-system';

import { parseVersionHistoryText } from '@/features/factsheet/lib/versionHistory';
import { useIsFactsheetCompact } from '@/features/factsheet/state/useIsFactsheetCompact';
import type { FactsheetDetails } from '@/features/factsheet/types';
import { cn } from '@/lib/utils';

import TextLinesDisplay from '../TextLinesDisplay';

interface ApproachTabProps {
  factsheet: FactsheetDetails;
}

interface TradeDataRowProps {
  label: string;
  value: boolean | string | undefined;
}

const TradeDataRow = ({ label, value }: TradeDataRowProps) => {
  const isCompact = useIsFactsheetCompact();

  return (
    <div className='flex flex-row items-center justify-between gap-3 pt-1'>
      <span className={cn(isCompact && 'text-sm')}>{label}</span>
      <span className={cn(isCompact && 'text-sm')}>{value ? 'Y' : 'N'}</span>
    </div>
  );
};

const TradeDataApproachSection = ({ factsheet }: { factsheet: FactsheetDetails }) => {
  const isCompact = useIsFactsheetCompact();

  return (
    <div className='flex flex-1 flex-col'>
      <div className='flex flex-row items-center justify-between py-1'>
        <p className={cn('font-bold', isCompact && 'text-sm')}>Trade Data Approach</p>
        <p className={cn('font-bold', isCompact && 'text-sm')}>Y/N</p>
      </div>
      <Separator className='bg-gx-text' />
      <TradeDataRow
        label='Priority to reported and concluded transactions'
        value={factsheet.priorityToTransactions}
      />
      <TradeDataRow
        label='Sole-sourced data from trading principals accepted'
        value={factsheet.soleSourcedDataAccepted}
      />
      <TradeDataRow
        label='Inter-affiliate data accepted as valid'
        value={factsheet.interAffiliateDataAccepted}
      />
    </div>
  );
};

const ApproachTab = ({ factsheet }: ApproachTabProps) => {
  const isCompact = useIsFactsheetCompact();
  const approachLines = parseVersionHistoryText(factsheet, 'calculationApproach');

  return (
    <div className={cn('flex justify-start gap-5', isCompact ? 'flex-col' : 'flex-row')}>
      <TradeDataApproachSection factsheet={factsheet} />
      {approachLines && (
        <div className='flex flex-1 flex-col'>
          <TextLinesDisplay
            lines={approachLines}
            className={isCompact ? 'text-sm' : undefined}
          />
        </div>
      )}
    </div>
  );
};

export default ApproachTab;
